import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router"
import config from '../../config.json'
import { HIGHLIGHT } from '../../constants/itemTypes'
import toJS from '../../hoc/toJS'
import { highlightsDeleteItem } from '../../actions'
import getData from '../../functions/getData'
import { PROGRAM_HIGHLIGHTS, AUTH_CAPS } from '../../constants/state'
import canEditProgram from '../../functions/canEditProgram'
import ListDrag from '../../components/DragAndDropList/presents/ListDrag'
import ProgramDragDropItemSwitch from '../../components/PageEditSelection/ProgramDragDropItemSwitch'
import dndItemTypes from '../../constants/dndItemTypes'

const mapStateToProps = state => ({
    items: getData(state, PROGRAM_HIGHLIGHTS),
    caps: getData(state, AUTH_CAPS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({    
    removeItem: (itemID) => {
        dispatch(highlightsDeleteItem(itemID))
    }
})

const ProgramListHighlightsContainer = ({
    titleTransId, 
    buttonTextTransId, 
    className, 
    items, 
    caps,
    match,
    isAllOpen,
    setAllOpen,
    removeItem
}) => {
    const { selectionId, selectionType } = match.params

    const basicUrl = `${config.routes.program.path}/${selectionType}/${selectionId}`
    const pathnameAdd = `${basicUrl}/${HIGHLIGHT}/addItem/form`
    const canEdit = canEditProgram(caps)
    const order = Object.keys(items)

    return <ListDrag
        titleTransId={titleTransId}
        buttonTextTransId={buttonTextTransId}
        listId={'highlight-'  + selectionId}
        dndType={dndItemTypes.PROGRAM_ITEM_AD}
        className={className}

        type={HIGHLIGHT}
        order={order}
        items={items}

        ChildSwitchItem={ProgramDragDropItemSwitch}

        params={false}
        basicUrl={basicUrl}

        defaultIsOpen={isAllOpen}
        setAllOpen={setAllOpen}

        canEdit={canEdit}
        canDelete={canEdit}
        pathnameAdd={pathnameAdd}
        deleteItem={removeItem}
    />
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ProgramListHighlightsContainer)